module.exports = __webpack_public_path__ + "images/pencil-836d73db.svg";